import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/** Gates every route behind login (CLAUDE.md "the whole app is behind login — no anonymous
 * access"). Shows nothing while the initial /auth/me check is in flight, to avoid a login-page
 * flash for an already-logged-in member. */
export function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Outlet />;
}
